<template>
  <div class="data-source_container">
    <button class="data-source" @click="toggleWidget" ref="dataSource">
      <template v-if="type === 'source'">
        <div ref="leaderStart" class="data-source_leader-base right source"></div>
      </template>
      <div class="data-source_info mb-1">
        <b-alert
          class="error"
          v-if="error"
          :show="dismissErrorCountDown"
          dismissible
          @dismissed="dismissErrorCountDown=0"
          @dismiss-count-down="errorCountDownChanged">{{error}}</b-alert>
        <b-alert
          class="success"
          :show="dismissCountDown"
          dismissible
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged" >{{success}}</b-alert>
        <span class="data-source_expand-icon" :class="{open: widgetIsOpen}"></span>
        <svg-icon
          :icon-name="dataSource.type"
          :icon-size="50"/>
        <div class='data-source_info-box'>
          <p style='font-weight: bold'>{{dataSource.company_name}}</p>
        </div>
      </div>
      <lottie-animation
        :animation-id="plugAnimationID"
        :options="aniData"
        :width="40"
        :height="40"
        :speed="1.2"></lottie-animation>
    </button>
    <template>
      <transition
        :duration="450"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave">
        <div
          class="expandable"
          v-show="widgetIsOpen"
          tabindex="0">
          <component v-bind:is="mappable + 'Map'"
            :crmData="dataSource"
            :save-button-text="saveButtonText"
            @finished="saveData"
            @close="closeWidget"
            @deleteData="deleteDataConfirm"
            @save="save"/>
        </div>
      </transition>
    </template>
    <ModalConfirm
          v-if="showModalConfirm"
          :message="deleteMessage"
          @confirm="deleteData"
          @cancel="showModalConfirm = false"></ModalConfirm>
  </div>
</template>
<script>
import CRMMap from '@/components/CRMMap.vue'
import ModalConfirm from '@/components/ModalConfirm.vue'
import AnalyticsMap from '@/components/AnalyticsMap.vue'
import AnalyticsRport from '@/api/Analytics/AnalyticsReport.js'
import { setTimeout } from 'timers'
import LottieAnimation from '@/components/LottieAnimation.vue'
import * as plugAnimation from '@/assets/lottie/plugs.json'
import SVGIcon from '@/components/SVGIcon.vue'
import CrmConnections from '@/api/CRM/CrmConnections.js'

export default {
  name: 'data-source',
  components: {
    CRMMap,
    AnalyticsMap,
    ModalConfirm,
    LottieAnimation,
    'svg-icon': SVGIcon
  },
  props: {
    dataSource: {
      type: Object
    },
    mappable: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    index: {
      type: Number
    }
  },
  data () {
    return {
      widgetIsOpen: false,
      showModalConfirm: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissErrorCountDown: 0,
      leaderLine: null,
      filledOut: false,
      aniData: {
        animationData: plugAnimation.default,
        autoplay: false,
        loop: false
      },
      plugAnimationID: 'plug_animation' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10),
      saveButtonText: 'Save & Close',
      deleteMessage: '',
      error: '',
      success: ''
    }
  },
  watch: {
    filledOut (newValue) {
      if (newValue) {
        this.leaderLine.color = '#CE25DD'
      } else {
        this.leaderLine.color = '#9D9D9D'
      }
    }
  },
  computed: {

  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      this.$store.commit('updateLeaderLines')
    },
    errorCountDownChanged (dismissCountDown) {
      this.dismissErrorCountDown = dismissCountDown
      this.$store.commit('updateLeaderLines')
    },
    save (value) {
      this.success = value
      this.dismissCountDown = this.dismissSecs
      this.closeWidget()
    },
    saveData () {
      this.saveButtonText = 'Saved!'
      setTimeout(() => {
        this.closeWidget()
        setTimeout(() => {
          this.filledOut = true
          this.saveButtonText = 'Save & Close'
        }, 1000)
      }, 750)
    },
    deleteDataConfirm () {
      if (this.mappable === 'CRM') {
        this.deleteMessage = 'Are you sure you want to delete the CRM'
      }
      if (this.mappable === 'analytics') {
        this.deleteMessage = 'Are you sure you want to delete this Analytics'
      }
      this.showModalConfirm = true
    },
    deleteData () {
      if (this.mappable === 'CRM') {
        this.showModalConfirm = false
        this.$store.commit('deleteLeaderLines')
        CrmConnections.deleteCrm(this.dataSource.crm_connection_id)
          .then(response => {
            if (response.error) {
              this.dismissErrorCountDown = this.dismissSecs
              this.error = response.error

              this.$nextTick(() => {
                this.$store.commit('updateLeaderLines')
              })
            } else {
              this.getCrm()
            }
          })
      }
      if (this.mappable === 'analytics') {
        this.showModalConfirm = false
        AnalyticsRport.DeleteAAConnection({ 'adobe_connection_id': this.dataSource.adobe_connection_id })
          .then(response => {
            if (response.error) {
              this.dismissErrorCountDown = this.dismissSecs
              this.error = response.error

              this.$nextTick(() => {
                this.$store.commit('updateLeaderLines')
              })
            } else {
              this.getAAConnection()
            }
          })
        setTimeout(() => {
          this.$store.commit('deleteLeaderLines')
          AnalyticsRport.getAAConnection()
        }, 500)
      }
      this.closeWidget()
    },
    getCrm () {
      CrmConnections.getCrm()
    },
    getAAConnection () {
      AnalyticsRport.getAAConnection()
    },
    toggleWidget () {
      this.widgetIsOpen ? this.closeWidget() : this.openWidget()
    },
    openWidget () {
      this.widgetIsOpen = true
      this.$store.commit('updateLeaderLines')
      this.$store.dispatch('ux/spotlightElement', { element: this.$el, runAfterTurningOff: this.closeWidget })

      this.$store.commit('lottiePlay', {
        animationID: this.plugAnimationID,
        reverse: true
      })
    },
    closeWidget () {
      this.widgetIsOpen = false
      this.$store.commit('updateLeaderLines')
      this.$store.dispatch('ux/turnOffSpotlight')
      this.$refs.dataSource.focus()

      this.$store.commit('lottiePlay', {
        animationID: this.plugAnimationID
      })
    },
    beforeEnter: function (el) {
      el.style.maxHeight = '0'
    },
    enter: function (el) {
      el.style.maxHeight = el.scrollHeight + 'px'

      setTimeout(() => {
        el.style.maxHeight = 'none'
        el.classList.add('open')
        el.focus()
      }, 400)
    },
    beforeLeave: function (el) {
      el.style.maxHeight = el.scrollHeight + 'px'
      el.classList.remove('open')
      setTimeout(() => {
        el.style.maxHeight = '0'
      }, 50)
    },
    drawLeaderLines () {
      const startElement = this.type === 'source' ? this.$refs.leaderStart : document.getElementById('stitcher_leader_line_start')
      const endElement = this.type === 'source' ? document.getElementById('stitcher_leader_line_end') : this.$el
      const options = {
        color: this.type === 'source' ? '#CE25DD' : '#2BAEB5',
        path: 'fluid',
        hide: true,
        startSocket: 'right',
        endSocket: 'left'
      }

      this.leaderLine = new LeaderLine(
        startElement,
        endElement,
        options
      )

      this.leaderLine.show(['draw'])

      this.$store.commit('addLeaderLine', this.leaderLine)
    }
  },
  mounted () {
    setTimeout(() => {
      this.drawLeaderLines()

      this.$store.commit('lottiePlay', {
        animationID: this.plugAnimationID
      })

      if (this.dataSource.new) {
        this.openWidget()
      }
    }, 300)
  },
  beforeDestroy () {
    this.leaderLine.remove()
  },
  updated () {
    this.$store.commit('updateLeaderLines')
  }

}
</script>
